const FACTS = [
  { label: "Based at", value: "Lake Anna, VA" },
  { label: "Coverage", value: "10+ miles of lake" },
  { label: "Drones flown", value: "DJI Mini 5 Pro · 4 Pro" },
  { label: "Pilot", value: "FAA Part 107" },
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-40 border-t border-white/5 bg-[#070B16]"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid md:grid-cols-12 gap-12 md:gap-16">
          <div className="md:col-span-7 md:order-1 space-y-6">
            <p className="text-lg md:text-xl text-white/80 leading-relaxed font-light">
              Aqua Aerials LKA is a Lake Anna-based drone studio focused on the
              kind of footage that makes the lake feel like a place worth
              remembering. We fly the DJI Mini 5 Pro and DJI Mini 4 Pro across
              10+ miles of lake to work with homeowners, realtors, boat owners,
              and families looking for something more memorable than a phone
              clip.
            </p>
            <p className="text-base text-white/60 leading-relaxed font-light">
              Every shoot is planned around light, weather, and water — and
              delivered fast. We&apos;re responsive, FAA-licensed, and serious
              about getting it right the first time.
            </p>

            <div className="grid grid-cols-2 gap-px bg-white/10 mt-12 border border-white/10">
              {FACTS.map((f) => (
                <div
                  key={f.label}
                  className="bg-[#070B16] p-6 md:p-8"
                  data-testid={`fact-${f.label.replace(/\s+/g, "-").toLowerCase()}`}
                >
                  <div className="overline mb-3 text-white/40">{f.label}</div>
                  <div className="font-mono text-xl md:text-2xl text-white">
                    {f.value}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="md:col-span-5 md:order-2">
            <span className="overline">§ 05 — The Studio</span>
            <h2 className="mt-6 text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white">
              A small studio
              <br />
              <span className="text-[#E5A93B]">on a big lake.</span>
            </h2>
          </div>
        </div>
      </div>
    </section>
  );
};
